import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import EACourse from './pages/EACourse';
import USTaxation from './pages/USTaxation';
import BusinessSetup from './pages/BusinessSetup';
import About from './pages/About';
import FAQPage from './pages/FAQPage';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import { Toaster } from './components/ui/toaster';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    document.title = 'Eduvantage — Enrolled Agent Course & US Taxation Training';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ea-course" element={<EACourse />} />
          <Route path="/us-taxation" element={<USTaxation />} />
          <Route path="/business-setup" element={<BusinessSetup />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
